/* eslint-disable max-len */
import { ApolloError } from '@apollo/client';
import { getDefectTypeOutput } from '../../../../api';
import { manageCodeLabelColumns } from '../../../../components';
import { defectType } from '../../../../entityModel';
import { ManageDefectTypesTableBody } from './ManageDefectTypesTableBody';
import { ManageDefectTypesTableHead } from './ManageDefectTypesTableHead';

interface ManageDefectTypesTableProps {
  error?: ApolloError;
  loading: boolean;
  data?: getDefectTypeOutput;
  onEdit: (defectType: defectType) => void;
  onDelete: (defectType: defectType) => void;
}

export const ManageDefectTypesTable = ({ error, loading, data, onEdit, onDelete, ...rest }: ManageDefectTypesTableProps) => {
  return (
    <table className="table table-bordered">
      <ManageDefectTypesTableHead
        columns={manageCodeLabelColumns}
      />
      <ManageDefectTypesTableBody
        columns={manageCodeLabelColumns}
        loading={loading}
        error={error}
        data={data}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </table>
  );
};
